import { TSectionState } from '../../types/section';

const defaultState: TSectionState = null;

export function sectionReducer(state: TSectionState = defaultState): TSectionState {
  return state;
}
